module.exports = __webpack_public_path__ + "img/white-logo-removebg.5c61c5b4.png";